export const SUPPORTED_LANGUAGES = [
  'English',
  'Dansk',
  'Deutsch',
  'Español',
  'Français',
  'Português',
  '日本語',
  '한국어',
  '中文'
] as const;

export type SupportedLanguage = typeof SUPPORTED_LANGUAGES[number];

export const DEFAULT_LANGUAGE: SupportedLanguage = 'English';

export const LANGUAGE_CODES: Record<SupportedLanguage, string> = {
  English: 'en',
  Dansk: 'da',
  Deutsch: 'de',
  Español: 'es',
  Français: 'fr',
  Português: 'pt',
  '日本語': 'ja',
  '한국어': 'ko',
  '中文': 'zh',
};
